import React from 'react';

const Animation = () => {
    return (
        <div className='sm:text-center mb-[-8px]'>
            <h1 className='bg-slate-700 py-[1.25rem] text-white lg:text-4xl md:text-3xl sm:text-xs'>
                <marquee className='' behavior="alternate" direction="right">Anjuli Automobiles Pvt. Ltd. <span> - 8750270991,
                    9873580735</span></marquee>
            </h1>
        </div>
    );
};

export default Animation;